import { SListTabs } from 'shj-components'
import { Radio, Input, Spin, message } from 'antd'
import { useEffect, useState } from 'react'
import {
  listBudgetDtlByDiff,
  queryProjectTree,
  subSearchListProcess,
  quoteBudgetItemTree,
  quoteBudgetSelectQuoteBudgetInfo,
  saveReviewApproval,
  queryReviewApproval
} from '@/services/order'
import { useSetState } from "ahooks";
import { getUser } from 'shj-utils'
import BudgetPrice from '../BudgetPrice'
import DrawingManagement from '../DrawingManagement'
import DragTable from '../DragTable'
import {
  config,
  addConfig,
  subConfig,
  disconutConfig,
  uporDownConfig,
} from './config'
import styles from './index.module.less';

const { TextArea } = Input

export default function ProjectDetail({
  flowData = {}
}) {
  const user = getUser()
  const [chooseTab, setChooseTab] = useState<any>('')
  const [orderStatusList, setOrderStatusList] = useState<Array<any>>([])
  const [typeList, setTypeList] = useState<any>([])
  const [spaceList, setSpaceList] = useState<any>([])
  const [activeSpaceIdPath, setActiveSpaceIdPath] = useState<any>('')
  const [tableConfig, setTableConfig] = useState<any>(config) // 列表配置
  const [quoteBudgetInfo, setQuoteBudgetInfo] = useState<any>({})
  const [remarkTextMap, setRemarkTextMap] = useSetState<any>({})
  const [nowRemarkText, setNowRemarkText] = useState<any>('')
  const [originReviewDataList, setOriginReviewDataList] = useState<any[]>([])
  const [dataSource, setDataSource] = useState<Array<any>>([])
  const [loading, setLoading] = useState(false)

  // 页面初始化
  useEffect(() => {
    if (flowData?.variables?.entity?.quoteBudgetId) {
      init();
      getReviewData();
    }
  }, [flowData])

  useEffect(() => {
    setNowRemarkText(chooseTab === 'CHOOSE' ? remarkTextMap?.[activeSpaceIdPath]?.remarks : remarkTextMap?.[chooseTab]?.remarks)
  }, [activeSpaceIdPath, chooseTab])

  const getReviewData = async () => {
    const res = await queryReviewApproval({
      params: {
        quotationFlowId: flowData?.variables?.quotationFlowId
      }
    })
    if (res?.reviewApprovalList?.length) {
      setOriginReviewDataList(res?.reviewApprovalList)
      // 将list转化为map
      const textMap = {};
      res?.reviewApprovalList?.forEach(approve => {
        if (approve?.remarks) {
          if (approve?.pathName === '报价费用') {
            textMap['quoteDetail'] = {
              idPath: 'quoteCost',
              pathName: '报价费用',
              remarks: approve?.remarks,
            } 
          } else if (approve?.pathName === '整装图纸') {
            textMap['diagram'] = {
              idPath: 'drawing',
              pathName: '整装图纸',
              remarks: approve?.remarks,
            } 
          } else if (approve?.pathName === '增项') {
            textMap['ADD'] = {
              idPath: approve?.idPath,
              pathName: approve?.pathName,
              remarks: approve?.remarks,
            } 
          } else if (approve?.pathName === '减项') {
            textMap['SUB'] = {
              idPath: approve?.idPath,
              pathName: approve?.pathName,
              remarks: approve?.remarks,
            } 
          } else if (approve?.pathName === '升降级') {
            textMap['UP_DOWN'] = {
              idPath: approve?.idPath,
              pathName: approve?.pathName,
              remarks: approve?.remarks,
            } 
          } else if (approve?.pathName === '优惠活动') {
            textMap['ACTIVITY'] = {
              idPath: approve?.idPath,
              pathName: approve?.pathName,
              remarks: approve?.remarks,
            } 
          } else {
            textMap[approve?.idPath] = {
              idPath: approve?.idPath,
              pathName: approve?.pathName,
              remarks: approve?.remarks,
            } 
          }
        }
      })
      setRemarkTextMap({
        ...textMap,
      })
    }
  }

  const getTopData = (budgetId: any, quotationFlowId: any) => {
    quoteBudgetSelectQuoteBudgetInfo({
      params: {
        quoteBudgetId: budgetId,
        quotationFlowId,
      },
    }).then((res: any) => {
      setQuoteBudgetInfo(res || {})
    })
  }

  const init = async () => {
    const res = await quoteBudgetItemTree({
      params: {
        quoteBudgetId: flowData?.variables?.entity?.quoteBudgetId
      }
    })
    if (Array.isArray(res)) {
      const typeList = res.map(item => ({
        label: item.label + (item.object?.summaryAmount ? `(￥${item.object?.summaryAmount})` : ''),
        key: item.object?.code,
        idPath: item.object?.idPath,
      }))
      setTypeList(res);
      setOrderStatusList([{ label: '报价费用', key: 'quoteDetail' }, ...typeList, { label: '图纸', key: 'diagram' }]);
      setChooseTab('quoteDetail')
    }
    await getTopData(flowData?.variables?.entity?.quoteBudgetId, flowData?.variables?.quotationFlowId)
  }

  const handleChangeChart = (item) => {
    const space = spaceList?.filter((spa: any) => spa?.id === item?.target?.value);
    setActiveSpaceIdPath(space?.[0]?.object?.idPath || '');
    fetchList(item?.target?.value, 'CHOOSE')
  }

  // 获取数据
  const fetchList = async (refItemId, tab) => {
    setLoading(true)
    let locakSearch = {}
    return new Promise(async (resolve, reject) => {
      if (flowData?.variables?.entity?.quoteBudgetId && refItemId) {
        let resData: any
        try {
          if (tab !== 'SUB') {
            resData = await listBudgetDtlByDiff({
              budgetId: flowData?.variables?.entity?.quoteBudgetId,
              refItemId,
              quotationFlowId: flowData?.variables?.quotationFlowId
            })
          } else {
            resData = await subSearchListProcess({
              budgetId: flowData?.variables?.entity?.quoteBudgetId,
              refItemId,
              quotationFlowId: flowData?.variables?.quotationFlowId
            })
          }
          // getTableConfig(resData, flowData?.variables?.entity?.quoteBudgetId)
          resData = resData.map((item: any, index) => {
            return {
              ...item,
              orderSeq: index + 1,
              key: item.key || index + 1,
            }
          })
          locakSearch = {
            firstValue: flowData?.variables?.entity?.quoteBudgetId || refItemId, //通项id 目前暂为一级
            secondValue: flowData?.variables?.entity?.quoteBudgetId || refItemId, //通项id
            prdCateId: orderStatusList?.[0]?.key, // 树选中值
          }
          localStorage.setItem('quoteSelectionSearch', JSON.stringify(locakSearch))
          setDataSource([...resData])
          setLoading(false)
        } catch (err) {
          reject({ success: false })
          setLoading(false)
        }
      } else {
        reject({ success: false })
        setLoading(false)
      }
    })
  }

  const handleChangeTab = async (tab, b, c) => {
    console.log(tab, b, c)
    setChooseTab(tab)
    setDataSource([])
    const hasOperate = (flowData?.currentAuditList?.[0]?.nodeId === 'Activity_1dt25d3') && (flowData?.currentAuditList?.[0]?.nodeWorkNumberList?.includes(user?.userId))
    if (tab === 'CHOOSE') {
      setLoading(true)
      const res = await queryProjectTree({
        params: {
          quoteBudgetId: flowData?.variables?.entity?.quoteBudgetId,
          prdCateId: typeList?.filter(item => item?.object?.code === tab)?.[0]?.id,
          quotationFlowId: flowData?.variables?.quotationFlowId,
          updateQuote: true,
        }
      })
      setLoading(false)
      if (Array.isArray(res)) {
        setSpaceList(res);
        setActiveSpaceIdPath(res?.[0]?.object?.idPath)
      }
      setTableConfig(hasOperate ? config : {...config, columns: config?.columns?.filter(item => item?.title !== '操作')})
      fetchList(res?.[0]?.id, tab)
    } else {
      setSpaceList([])
    }
    if (tab !== 'CHOOSE' && tab !== 'quoteDetail' && tab !== 'diagram') {
      const refId = typeList?.filter(item => item?.object?.code === tab)?.[0]?.id
      switch (tab) {
        case 'ADD':
          // 增项选材
          setTableConfig(hasOperate ? addConfig : {...addConfig, columns: addConfig?.columns?.filter(item => item?.title !== '操作')})
          fetchList(refId, tab)
          break
        case 'SUB':
          // 减项选材
          setTableConfig(hasOperate ? subConfig : {...subConfig, columns: subConfig?.columns?.filter(item => item?.title !== '操作')})
          fetchList(refId, tab)
          break
        case 'ACTIVITY':
          // 优惠选材
          setTableConfig(hasOperate ? disconutConfig : {...disconutConfig, columns: disconutConfig?.columns?.filter(item => item?.title !== '操作')})
          fetchList(refId, tab)
          break
        case 'UP_DOWN':
          // 减项选材
          setTableConfig(hasOperate ? uporDownConfig : {...uporDownConfig, columns: uporDownConfig?.columns?.filter(item => item?.title !== '操作')})
          fetchList(refId, tab)
          break
        default:
          break
      }
    }
  }

  const handleChangeRemark = (e: any) => {
    setNowRemarkText(e.target.value)
    if (chooseTab === 'quoteDetail') {
      setRemarkTextMap({
        quoteDetail: {
          idPath: 'quoteCost',
          pathName: '报价费用',
          remarks: e.target.value,
        }
      })
    }
    if (chooseTab === 'diagram') {
      setRemarkTextMap({
        diagram: {
          idPath: 'drawing',
          pathName: '整装图纸',
          remarks: e.target.value,
        }
      })
    }
    if (chooseTab === 'CHOOSE') {
      setRemarkTextMap({
        [activeSpaceIdPath]: {
          idPath: activeSpaceIdPath,
          pathName: '选材',
          remarks: e.target.value,
        }
      })
    }
    if (chooseTab === 'ADD') {
      const tab = orderStatusList?.filter(item => item?.key === 'ADD');
      setRemarkTextMap({
        ADD: {
          idPath: tab?.[0]?.idPath,
          pathName: tab?.[0]?.label,
          remarks: e.target.value,
        }
      })
    }
    if (chooseTab === 'SUB') {
      const tab = orderStatusList?.filter(item => item?.key === 'SUB');
      setRemarkTextMap({
        SUB: {
          idPath: tab?.[0]?.idPath,
          pathName: tab?.[0]?.label,
          remarks: e.target.value,
        }
      })
    }
    if (chooseTab === 'UP_DOWN') {
      const tab = orderStatusList?.filter(item => item?.key === 'UP_DOWN');
      setRemarkTextMap({
        UP_DOWN: {
          idPath: tab?.[0]?.idPath,
          pathName: tab?.[0]?.label,
          remarks: e.target.value,
        }
      })
    }
    if (chooseTab === 'ACTIVITY') {
      const tab = orderStatusList?.filter(item => item?.key === 'ACTIVITY');
      setRemarkTextMap({
        ACTIVITY: {
          idPath: tab?.[0]?.idPath,
          pathName: tab?.[0]?.label,
          remarks: e.target.value,
        }
      })
    }
  }

  const handleSaveRemark = async () => {
    try {
      const reviewApprovalList = Object.keys(remarkTextMap)?.map(key => ({
        pathName: remarkTextMap?.[key]?.pathName,
        idPath: remarkTextMap?.[key]?.idPath,
        remarks: remarkTextMap?.[key]?.remarks,
      }))
      const newList = originReviewDataList?.map(item => {
        const itemInfo = reviewApprovalList?.filter(approve => approve?.idPath === item?.idPath);
        if (itemInfo?.length) {
          return {
            ...item,
            remarks: itemInfo?.[0]?.remarks
          }
        }
        return {
          ...item,
        }
      })
      await saveReviewApproval({
        id: flowData?.variables?.quotationFlowId,
        reviewApprovalList: newList,
      })
      message.success('保存批复成功')
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <div className={styles.projectDetailBox}>
      <Spin spinning={loading}>
        <div>
          <SListTabs activeKey={chooseTab} items={orderStatusList} hideExtra={false} onChange={handleChangeTab} auth={undefined} />
          {
            chooseTab === 'CHOOSE' && spaceList?.length ? (
              <Radio.Group
                defaultValue={spaceList?.[0]?.id || ''}
                style={{ marginTop: '10px' }}
                size="small"
                onChange={handleChangeChart}
              >
                {
                  spaceList?.map(item => (
                    <Radio.Button
                      className={ (item?.object?.updateQuote || item?.object?.updateType === 'ADD') ? (activeSpaceIdPath === item?.object?.idPath) ? styles?.updateCheckButton : styles?.updateButton : (activeSpaceIdPath === item?.object?.idPath) ? styles?.changeButton : '' }
                      value={item?.id}
                    >
                      { item?.object?.showName }
                    </Radio.Button>
                  ))
                }
              </Radio.Group>
            ) : null
          }
          <div style={{ width: '100%', marginTop: '10px' }}>
            <TextArea
              value={nowRemarkText || ''}
              onChange={(e) => handleChangeRemark(e)}
              placeholder='请填写审核批复，不超过1000字'
              rows={2}
              maxLength={1000}
              disabled={!(!(flowData?.variables?.creator === user?.userId && flowData?.currentAuditList?.[0]?.nodeId === 'Activity_1dt25d3') && !flowData?.isEnd && flowData?.isAudit)}
              onBlur={() => {
                handleSaveRemark()
              }}
            />
          </div>
          {
            chooseTab === 'quoteDetail' && quoteBudgetInfo?.id ? (
              <BudgetPrice
                couldEdit={
                  quoteBudgetInfo?.state === 'budgetDraft' && !quoteBudgetInfo?.frozenFlag
                }
                quoteBudgetInfo={quoteBudgetInfo}
                budgetId={quoteBudgetInfo?.id}
                quotationFlowId={flowData?.variables?.quotationFlowId}
              ></BudgetPrice>
            ) : null
          }
          {
            chooseTab === 'diagram' ? (
              <DrawingManagement
                quoteBudgetId={flowData?.variables?.entity?.quoteBudgetId}
                quotationFlowId={flowData?.variables?.quotationFlowId}
              />
            ) : null
          }
          {
            chooseTab !== 'diagram' && chooseTab !== 'quoteDetail' ? (
              <div style={{ paddingBottom: '20px', marginTop: '10px' }}>
                <DragTable
                  flowData={flowData}
                  tableConfig={tableConfig}
                  dataSource={dataSource}
                  setDataSource={setDataSource}
                  chooseTab={chooseTab}
                />
              </div>
            ) : null
          }
        </div>
      </Spin>
    </div>
  )
}
